// Tâche 1458 (Eric 2026-06) — Filtres par catégorie de connaissance.
//
// > « ajout des filtres pour permettre de ne regarder que certaines catégories
// >   ou types de connaissances, voire toutes »
//
// Deux décisions portées par cet écran :
//   • Les catégories affichées sont celles PRÉSENTES dans le balayage, et le
//     compte est dit pour chacune. Afficher une case « Procédures (0) » ferait
//     chercher une faute qui n'existe pas.
//   • Le filtre ne relance AUCUN balayage : il cache, il ne recalcule pas.
//     Relancer effacerait le tri déjà fait (tâche 1455).
import { useLang } from "../../contexts/LanguageContext";

export const FiltresZones = ({ comptes, libellesZone, selection, onChanger }) => {
  const { lang, tr } = useLang();
  const zones = Object.keys(comptes || {}).filter((z) => comptes[z] > 0);
  if (zones.length <= 1) return null;

  const etiquette = (zone) => {
    const paire = libellesZone?.[zone];
    if (!paire) return zone;
    return lang === "en" ? paire[1] : paire[0];
  };

  const basculer = (zone) => {
    if (selection.includes(zone)) onChanger(selection.filter((z) => z !== zone));
    else onChanger([...selection, zone]);
  };

  const total = zones.reduce((n, z) => n + comptes[z], 0);
  const toutes = selection.length === 0;

  return (
    <div className="flex flex-wrap items-center gap-1.5 mb-3"
         data-testid="orthographe-filtres-zones">
      <span className="text-[11px] text-zinc-500 mr-1">
        {tr("Afficher :", "Show:")}
      </span>
      <button
        type="button"
        onClick={() => onChanger([])}
        className={`px-2 py-1 rounded-full text-[11px] border transition-colors ${
          toutes
            ? "bg-[#002FA7] text-white border-[#002FA7]"
            : "bg-white text-zinc-600 border-zinc-300 hover:bg-zinc-50"
        }`}
        data-testid="orthographe-filtre-toutes"
      >
        {tr("Toutes", "All")} ({total})
      </button>
      {zones.map((zone) => {
        const actif = selection.includes(zone);
        return (
          <button
            key={zone}
            type="button"
            onClick={() => basculer(zone)}
            className={`px-2 py-1 rounded-full text-[11px] border transition-colors ${
              actif
                ? "bg-[#002FA7] text-white border-[#002FA7]"
                : "bg-white text-zinc-600 border-zinc-300 hover:bg-zinc-50"
            }`}
            data-testid={`orthographe-filtre-${zone}`}
          >
            {etiquette(zone)} ({comptes[zone]})
          </button>
        );
      })}
    </div>
  );
};

export default FiltresZones;
